<script>
import countlyVue from '../../compat/vue-core';
import i18n from '../../../../i18n';

export default countlyVue.components.BaseComponent.extend({
  props: {
    title: { type: String, required: false },
    link: { type: String, required: false },
  },
  methods: {
    back() {
      // TODO: implement
    },
  },
  computed: {
    innerTitle() {
      if (this.title) {
        return this.title;
      }
      return i18n.tc('common.back');
    },
  },
});
</script>
<template>
  <a
    class="cly-vue-back-link"
    @click="back"
  >
    <span class="text-medium bu-is-capitalized"><i class="fas fa-arrow-left bu-pr-3" />{{ innerTitle }}</span>
  </a>
</template>
